import { toast } from "sonner";
import { useTranslation } from "react-i18next";
import { ArrowRight, CheckCircle2, Crown, Lock } from "lucide-react";

/**
 * ProTierCard — the unlock-Pro / Pro-unlocked hero on the Streak page.
 * Progression is tied to the 12-month streak milestone.
 */
export default function ProTierCard({ data }) {
  const { t } = useTranslation();
  const unlocked = !!data.pro_unlocked;
  const monthsAway = Math.max(0, 12 - (data.current_streak || 0));
  const perks = [
    t("streak_kids.pro_perk_1"),
    t("streak_kids.pro_perk_2"),
    t("streak_kids.pro_perk_3"),
    t("streak_kids.pro_perk_4"),
  ];
  return (
    <div
      className={`card-flat p-8 relative overflow-hidden ${unlocked ? "" : "opacity-90"}`}
      style={unlocked ? {
        background: "linear-gradient(135deg, #21422F 0%, #2D5A40 100%)",
        color: "#FDFCFB",
        borderColor: "transparent",
      } : {}}
    >
      <div className="grid md:grid-cols-2 gap-8 items-center relative">
        <div>
          <div className="label-eyebrow" style={unlocked ? { color: "#FDFCFB", opacity: 0.85 } : {}}>
            {t("streak_kids.pfo_pro_eyebrow")}
          </div>
          <h2
            className="text-3xl md:text-4xl tracking-tighter mt-3"
            style={{ fontFamily: "var(--font-heading)", color: unlocked ? "#FDFCFB" : "var(--text-primary)" }}
          >
            {unlocked ? t("streak_kids.pro_unlocked_title") : t("streak_kids.pro_unlock_title")}
          </h2>
          <p
            className="mt-3 text-sm leading-relaxed"
            style={{ color: unlocked ? "rgba(255,255,255,0.85)" : "var(--text-secondary)" }}
          >
            {unlocked
              ? t("streak_kids.pro_unlocked_body")
              : t("streak_kids.pro_unlock_body", { count: monthsAway })}
          </p>
          <ul className="mt-5 space-y-2 text-sm" style={{ color: unlocked ? "rgba(255,255,255,0.9)" : "var(--text-primary)" }}>
            {perks.map((p) => (
              <li key={p} className="flex items-center gap-2">
                {unlocked ? <CheckCircle2 size={15} color="#E09E50"/> : <Lock size={13}/>} {p}
              </li>
            ))}
          </ul>
          {unlocked && (
            <button
              className="mt-6 btn-primary"
              style={{ background: "#E09E50", borderColor: "#E09E50", color: "#21422F" }}
              onClick={() => toast.success(t("streak_kids.claim_pro_toast"))}
              data-testid="claim-pro-btn"
            >
              {t("streak_kids.claim_pro_perks")} <ArrowRight size={15}/>
            </button>
          )}
        </div>
        <div className="flex justify-center">
          <div
            className="h-32 w-32 md:h-40 md:w-40 rounded-full flex items-center justify-center"
            style={{
              background: unlocked
                ? "radial-gradient(circle, rgba(224,158,80,0.6) 0%, rgba(224,158,80,0) 70%)"
                : "var(--bg-accent)",
            }}
          >
            <Crown size={unlocked ? 78 : 60} color={unlocked ? "#E09E50" : "var(--text-muted)"} strokeWidth={1.6}/>
          </div>
        </div>
      </div>
    </div>
  );
}
